// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2084 ? "9b0008ae" : chunkId) + "." + {"1029":"eae5f7bd47b195d0","2084":"e5178140b05662b8","3872":"17bd2eb2d2f5b020"}[chunkId] + ".js";
};